import Aboute from '../Aboute/Aboute';

function Main () {
    return (
       <main >
        <Aboute />
       </main>
    )
}

export default Main;